:host {
  hr {
    border: 0;
    border-top: var(--pine-border-width-thin) solid var(--pine-color-border);
    height: 0;
    margin-block: var(--pine-dimension-xs);
    margin-inline: calc(var(--pine-dimension-xs) * -1);
  }
}
